import * as React from "react";
import * as ReactDOM from "react-dom";
import { Button } from "antd";
import { GuideIndicator } from "./guideIndicator";
import { guidePopupStyle, highlightTextStyle, guideHeaderStyle, guideProgressStyle, guideSkipStyle } from "./styles";
import { GuideProps } from "./guides";

export const Legacy: React.FC<GuideProps> = ({ onDone, onSkip, currentStep, totalSteps }) => {
  const [step, setStep] = React.useState(0);
  const [position, setPosition] = React.useState({ top: 60, right: 50 });

  React.useEffect(() => {
    const updatePosition = () => {
      const element = document.querySelector('[data-guide="user-menu"]');
      if (element) {
        const rect = element.getBoundingClientRect();
        setPosition({ top: rect.bottom + 10, right: window.innerWidth - rect.right });
      }
    };

    updatePosition();
    window.addEventListener("resize", updatePosition);
    return () => window.removeEventListener("resize", updatePosition);
  }, []);

  React.useEffect(() => {
    if (step >= 1) {
      onDone();
    }
  }, [step]);

  if (step === 0) {
    return (
      <>
        <GuideIndicator selector='[data-guide="user-menu"]' borderRadius={20} />
        {ReactDOM.createPortal(
          <div style={{ position: "fixed", top: position.top, right: position.right, zIndex: 10001 }}>
            <div style={guidePopupStyle}>
              <div style={guideHeaderStyle}>
                <div className="font-semibold">
                  <span className="mr-4 text-sm uppercase">GUIDE</span>Switch to Legacy UI
                </div>
                <div style={guideProgressStyle}>{currentStep}/{totalSteps}</div>
              </div>
              <div className="text-sm mb-4">
                Welcome to the new Console interface. The{" "}
                <span style={highlightTextStyle}>highlighted profile menu</span> provides access to the
                legacy UI if needed.
              </div>
              <div className="text-sm mb-4">To switch back to the legacy interface:</div>
              <ul className="text-sm mb-4">
                <li className={"ml-4"} style={{ listStyleType: "disc" }}>
                  Click your profile icon
                </li>
                <li className={"ml-4"} style={{ listStyleType: "disc" }}>
                  Select "Use Legacy UI"
                </li>
              </ul>
              <div className="w-full flex justify-between items-center mt-4">
                <span style={guideSkipStyle} onClick={onSkip}>Skip all guides</span>
                <Button type={`primary`} onClick={() => setStep(1)}>
                  Got it
                </Button>
              </div>
            </div>
          </div>,
          document.getElementById("guide")!,
        )}
      </>
    );
  }

  return null;
};
